'use strict';

var react = require('@emotion/react');

const pillGroup = /*#__PURE__*/ react.css({
    display: "flex",
    gap: "4px",
    alignItems: "center"
}, "label:label-PillGroup-web-stylespillGroup", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2J1aWxkcy9kZXZlbG9wZXJzL2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL21vbGVjdWxlcy9QaWxsR3JvdXAvUGlsbEdyb3VwLndlYi5zdHlsZXMudHMiLCJzb3VyY2VzIjpbIi9idWlsZHMvZGV2ZWxvcGVycy9hdmlhcnkvcGFja2FnZXMvYXZpYXJ5LXdlYi9zcmMvY29tcG9uZW50cy9tb2xlY3VsZXMvUGlsbEdyb3VwL1BpbGxHcm91cC53ZWIuc3R5bGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuXG5leHBvcnQgY29uc3QgcGlsbEdyb3VwID0gY3NzKHtcbiAgZGlzcGxheTogXCJmbGV4XCIsXG4gIGdhcDogXCI0cHhcIixcbiAgYWxpZ25JdGVtczogXCJjZW50ZXJcIixcbn0pO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUV5QiJ9 */");

exports.pillGroup = pillGroup;
//# sourceMappingURL=PillGroup.web.styles.cjs.map
